module.exports = [
  '1199 SEIU National Benefit Fund',
  '6 Degrees Health Inc.',
  '90 Degree Benefits',
  'AARP',
  'Abri Health Plan',
  'ACA StandardHealth with Health Choice',
  'ACI Specialty Benefits EAP',
  'ACS Benefit Services',
  'APWU Health Plan',
  'ASR Health Benefits',
  'ATRIO Health Plans',
  'Absolute Total Care',
  'Acentra Health',
  'Advanced Health',
  'Adventist Health',
  'Advocate Health Partners (PHO)',
  'Aetna',
  'Aetna Better Health of Illinois',
  'Aetna Better Health of Kansas',
  'Aetna Better Health of Kentucky',
  'Aetna Better Health of Louisiana',
  'Aetna Better Health of Michigan',
  'Aetna Better Health of New Jersey',
  'Aetna Better Health of Ohio',
  'Aetna Better Health of Oklahoma',
  'Aetna Better Health of Pennsylvania',
  'Aetna Better Health of Texas',
  'Aetna Better Health of Virginia',
  'Aetna Better Health of West Virginia',
  'Aetna Resources For Living EAP',
  'Aither Health',
  'Alameda Alliance for Health',
  'Alignment Health Plan',
  'All Savers',
  'AllCare Health',
  'AllOne Health EAP',
  'Allegiance',
  'Alliance Coal Health Plan',
  'Alliance Health Plan',
  'Alliance Work Partners EAP',
  'Alliant Health Plans of Georgia',
  'Allied Benefit Systems',
  'Allina Health Aetna',
  'Allstate Health Benefits',
  'AlohaCare',
  'Alternatives EAP',
  'AmFirst Insurance Company',
  'Amalgamated Life Insurance Co.',
  'Ambetter',
  'AmeriBen',
  'AmeriHealth Caritas Louisiana',
  'AmeriHealth Caritas New Hampshire',
  'AmeriHealth Caritas Next (Delaware)',
  'AmeriHealth Caritas Next (North Carolina)',
  'AmeriHealth Caritas North Carolina',
  'AmeriHealth Caritas Ohio',
  'AmeriHealth Caritas Pennsylvania',
  'AmeriHealth Delaware',
  'AmeriHealth District of Columbia',
  'AmeriHealth HMO New Jersey and Delaware',
  'AmeriHealth New Jersey',
  'American Specialty Health',
  'Anthem',
  'Anthem Blue Cross',
  'Anthem Blue Cross Blue Shield',
  'Anthem Blue Cross Blue Shield Colorado',
  'Anthem Blue Cross Blue Shield Maine',
  'Anthem Blue Cross Blue Shield Nevada',
  'Anthem Blue Cross and Blue Shield Connecticut',
  'Anthem Blue Cross and Blue Shield Georgia',
  'Anthem Blue Cross and Blue Shield Indiana',
  'Anthem Blue Cross and Blue Shield Kentucky',
  'Anthem Blue Cross and Blue Shield Missouri',
  'Anthem Blue Cross and Blue Shield New Hampshire',
  'Anthem Blue Cross and Blue Shield Ohio',
  'Anthem Blue Cross and Blue Shield Wisconsin',
  'Anthem Blue Cross of California',
  'Anthem HealthKeepers',
  'Anthem Medical Ohio Medicaid',
  'Arizona Complete Health',
  'Arizona Medicaid (AHCCCS)',
  'Arizona Physicians IPA (APIPA)',
  'Ascension',
  'Aspire Health Plan',
  'Asuris Northwest Health',
  'AultCare',
  'Automated Benefit Services (ABS)',
  'Avera EAP',
  'Avera Health Plans',
  'BCBS BlueCare Family Plan (Connecticut)',
  'BPA Health EAP',
  'BRMS',
  'Balance EAP',
  'Banner Aetna',
  'Banner Health',
  'BayCare EAP',
  'Baylor Scott & White Health Plan',
  'Beacon',
  'Behavioral Health Systems',
  'Behavioral Health Systems (BHS) EAP',
  'Benefit Trust Life Insurance Company',
  'Best Care EAP',
  'Blomquist Hale EAP',
  'Blue Advantage (Louisiana)',
  'Blue Advantage of Arkansas',
  'Blue Care Network of Michigan',
  'Blue Choice Medicaid',
  'Blue Choice of Rochester NY',
  'Blue Cross',
  'Blue Cross Blue Shield',
  'Blue Cross Blue Shield EAP',
  'Blue Cross Blue Shield Federal Employee Program',
  'Blue Cross Blue Shield State Employee Plan',
  'Blue Cross Blue Shield of Alabama',
  'Blue Cross Blue Shield of Arizona',
  'Blue Cross Blue Shield of Illinois',
  'Blue Cross Blue Shield of Kansas',
  'Blue Cross Blue Shield of Kansas City',
  'Blue Cross Blue Shield of Louisiana',
  'Blue Cross Blue Shield of Massachusetts',
  'Blue Cross Blue Shield of Michigan',
  'Blue Cross Blue Shield of Minnesota',
  'Blue Cross Blue Shield of Mississippi',
  'Blue Cross Blue Shield of Montana',
  'Blue Cross Blue Shield of Nebraska',
  'Blue Cross Blue Shield of New Mexico',
  'Blue Cross Blue Shield of North Dakota',
  'Blue Cross Blue Shield of Oklahoma',
  'Blue Cross Blue Shield of Rhode Island',
  'Blue Cross Blue Shield of South Carolina',
  'Blue Cross Blue Shield of Tennessee',
  'Blue Cross Blue Shield of Texas',
  'Blue Cross Blue Shield of Vermont',
  'Blue Cross Blue Shield of Wyoming',
  'Blue Cross Community Centennial',
  'Blue Cross Community Solutions',
  'Blue Cross Complete of Michigan',
  'Blue Cross Medicare Advantage',
  'Blue Cross NC',
  'Blue Cross and Blue Shield of Texas STAR CHIP',
  'Blue Cross of Idaho',
  'Blue Shield',
  'Blue Shield of California',
  'Blue Shield of California Promise Health Plan',
  'Blue Shield of Kansas',
  'Blue Shield of Kansas City',
  'Blue Shield of Michigan',
  'Braven Health',
  'Bravo Health',
  'Bridgespan Health',
  'Buckeye Health Plan',
  'CBA Blue',
  'CDPHP',
  'CHAMPVA',
  'CalOptima Health',
  'Canopy EAP',
  'Cap Management Systems',
  'CapRock HealthPlans',
  'Capital Blue Cross',
  'Capital District PHP',
  'Capital Health Plan',
  'CareFirst BCBS - DC National Capital Area',
  'CareFirst BlueCross BlueShield',
  'CareGuard (Ametros)',
  'CareOregon',
  'CarePlus Health Plans',
  'CareSource',
  'CareSource of Arkansas',
  'CareSource of Georgia',
  'CareSource of Kentucky',
  'CareSource of Michigan',
  'CareSource of Ohio',
  'CareSource of West Virginia',
  'Carelon Behavioral Health',
  'Carelon Behavioral Health EAP',
  'Carelon Wellbeing / Anthem EAP Services',
  'Carepartners of Connecticut',
  'Caresource of Indiana',
  'Carolina Behavioral Health Alliance',
  'Carolina Care Plan',
  'Carolina Complete Health',
  'Cascade Centers EAP',
  'Cascade Health Alliance',
  'CenCal Health',
  'Centerstone EAP',
  'Centivo',
  'Central California Alliance for Health',
  'Charles Nechtem Associates EAP',
  `Children's Community Health Plan`,
  'Christus Health Plan',
  'Cigna Healthcare',
  'Cigna Healthcare Medicare Advantage',
  'Cigna Healthcare Medicare Arizona',
  'Claremont EAP',
  'Clover Health',
  'Coastline EAP',
  'College Health IPA (CHIPA)',
  'Colorado Access',
  'Colorado Community Health Alliance',
  'ComPsych',
  'ComPsych EAP',
  'Common Ground Healthcare Cooperative',
  'Commonwealth Care Alliance',
  'Commonwealth Care Alliance EAP',
  'Community Care Alliance',
  'Community Care Health Plan of Kansas',
  'Community Care Health Plan of Oklahoma',
  'Community First Health Plans',
  'Community Health Plan of Washington',
  'Comprehensive EAP',
  'Concern EAP',
  'ConnectiCare',
  'Connections Inc. EAP',
  'Consociate Group',
  'Consolidated Health Plans',
  'Continental Benefits',
  'Contra Costa Health Plan',
  `Cook Children's Health Plan`,
  `Cook Children's Star Plan`,
  'CorVel',
  'CorpCare EAP',
  'Corporate Benefits Service Inc. (NC)',
  'Corporation Benefit Services of America (CBSA)',
  'CountyCare',
  'Cox HealthPlans',
  'CuraLinc Healthcare',
  'CuraLinc Healthcare EAP',
  'Curative',
  'Custom Design Benefits',
  'DEA EAP',
  'Dean Health Plan',
  'Deer Oaks EAP',
  'Denver Health Medical Plan',
  'Deseret Mutual Benefit Administrators',
  'Detego Health',
  'Devoted Health',
  'Diversified Group Brokerage',
  'Driscoll Health Plan',
  'E4 Health EAP',
  'EBMS (Employee Benefit Management Services)',
  'EMI Health',
  'ENI EAP',
  'ERC EAP',
  'ESI EAP',
  'Early Intervention Central Billing',
  'El Paso Health',
  'Elevance Health',
  'EmblemHealth',
  'Empathia EAP',
  'Employee Benefit Services, Inc.',
  'Empower Healthcare Solutions',
  'Encore Health Network',
  'Endeavor Health',
  'Enterprise Group Planning',
  'Enticare',
  'Espyr EAP',
  'Essence Healthcare',
  'Essential Health Partners',
  'Evernorth Behavioral Health',
  'Evernorth Behavioral Health EAP',
  'Evernorth EAP',
  'Evolutions Healthcare',
  'Exceedent',
  'Excellus BlueCross BlueShield',
  'Expert Benefit Solutions',
  'FCHN EAP',
  'FEI EAP',
  'FMH Benefit Services',
  'Fallon Health',
  'Family Medical Network',
  'Federal Employee Program (Connecticut)',
  'Federal Employee Program (Michigan)',
  'Fidelis Care',
  'First Choice Health',
  'First Choice Health EAP',
  'First Choice Next',
  'First Health',
  'First Sun EAP',
  'Florida Blue',
  'Florida Health Plan',
  'Fox-Everett Inc.',
  'Freedom Claims Management',
  'Freedom Life Insurance Company',
  'Fringe Benefit Group',
  'FrontPath Health Coalition',
  'GEHA (Government Employees Health Association)',
  'Geisinger Health Plan',
  'Global Care Inc.',
  'Gravie Inc.',
  'Greater Oregon Behavioral Health, Inc. (GOBHI)',
  'Group Health Cooperative of South Central Wisconsin',
  'HAP Caresource',
  'HCSC Insurance Services Company',
  'HFN Inc.',
  'HMC HealthWorks',
  'HMSA EAP',
  'HUSKY Health',
  'Harvard Pilgrim Health Care',
  'Hawaii Management Alliance Association (HMAA)',
  'Hawaii Medical Service Association (HMSA)',
  'Headspace Care',
  'Health 2 Business',
  'Health Advocate EAP',
  'Health Alliance (Illinois)',
  'Health Alliance Plan (HAP) of Michigan',
  'Health Choice Utah',
  'Health Choice of Arizona',
  'Health First Colorado',
  'Health First Health Plans',
  'Health Net',
  'Health Net Behavioral Health',
  'Health Net of California',
  'Health Net of Oregon',
  'Health New England',
  'Health Payment Systems',
  'Health Plan of Nevada',
  'Health Plan of San Joaquin',
  'Health Plan of San Mateo',
  'Health Plans Inc.',
  'HealthCare Solutions Group',
  'HealthComp',
  'HealthEOS',
  'HealthEZ',
  'HealthPartners',
  'HealthPoint EAP',
  'HealthSpring',
  'HealthTeam Advantage',
  'Healthcare Highways',
  'Healthfirst',
  'Healthlink',
  'Healthscope',
  'Healthy Blue',
  'Healthy Blue Missouri',
  'Healthy Blue North Carolina',
  'Healthy Connections Medicaid',
  'Hennepin Health',
  'Highmark',
  'Highmark Blue Cross Blue Shield',
  'Highmark Blue Cross Blue Shield Delaware',
  'Highmark Blue Cross Blue Shield West Virginia',
  'Highmark Blue Cross Blue Shield Western New York Medicaid',
  'Highmark Blue Cross Blue Shield of Delaware (BCBSD)',
  'Highmark Blue Cross Blue Shield of Western New York',
  'Highmark Blue Shield',
  'Highmark Blue Shield of Northeastern New York',
  'Highmark Blue Shield of Pennsylvania',
  'Highmark Health Options West Virginia',
  'Highmark Senior Health Company',
  'Highmark Wholecare',
  'Holista',
  'Hometown Health Plan Nevada',
  'Horizon Blue Cross Blue Shield of New Jersey',
  'Horizon NJ Health',
  'Humana',
  'Humana EAP',
  'Humana Healthy Horizons Ohio',
  'III-A EAP',
  'IU Health Plan',
  'Idealcare',
  'Illinois Health Plan (IHP)',
  'Imagine Health',
  'Impact Solutions EAP',
  'Independence Blue Cross',
  'Independent Health',
  'Inland Empire Health Plan',
  'Innovation Health',
  'Insurance Management Services of Texas',
  'Integra Administrative Group',
  'Integrated Behavioral Health EAP',
  'Interactive Medical Systems',
  'Intercommunity Health Net',
  'Interface EAP',
  'Intermountain EAP',
  'Iowa Health Advantage',
  'Johns Hopkins Advantage MD',
  'Johns Hopkins Health Plans',
  'Johns Hopkins US Family Health Plan',
  'KGA EAP',
  'Kaiser Permanente',
  'Kaiser Permanente Colorado',
  'Kaiser Permanente Georgia',
  'Kaiser Permanente Hawaii',
  'Kaiser Permanente Mid-Atlantic States',
  'Kaiser Permanente Northern California',
  'Kaiser Permanente Northwest',
  'Kaiser Permanente Southern California',
  'Kaiser Permanente Washington',
  'KanCare',
  'Kern Health Systems',
  'Keystone First Community HealthChoices',
  'L.A. Care Health Plan',
  'LBA HealthPlans',
  'Liberty HealthShare',
  'Liberty Mutual',
  'Life Services EAP',
  'Life Solutions EAP',
  'Lifeprint',
  'Lifewise Assurance Company',
  'Lifewise Health Plan',
  'Lifewise Health Plan of Washington',
  'Lockard & Williams',
  'Loma Linda University Adventist',
  'Louisiana Healthcare Connections',
  'Loyola Physician Partners',
  'Lucent Health',
  'Lucet',
  'Lucet EAP',
  'Luminare Health',
  'Lyra Health',
  'Lytle EAP',
  'MDwise Health Indiana Plan',
  'MDwise Hoosier Healthwise',
  'MHNet Behavioral Health',
  'MHS Indiana',
  'MHS Wisconsin',
  'MINES and Associates',
  'MMM Multi Health',
  'MVP Healthcare',
  'Magellan Health',
  'MagnaCare',
  'Magnolia Health',
  'Maine Community Health Options',
  'MaineCare',
  'Managed Care Services',
  'Managed Care Services Nevada',
  'Martins Point Health Care',
  'Maryland Physicians Care',
  'Maryland Public Behavioral Health System',
  'MassHealth',
  'MassMutual',
  'Matrix EAP',
  'Mazzitti & Sullivan EAP',
  'McLaren Health Plan',
  'McLaren Health Plan Medicaid',
  'McLaughlin Young EAP',
  'MedCost',
  'MedCost Benefit Services',
  'Medi-Cal',
  'MediCal of California',
  'MediGold',
  'Medica',
  'Medica EAP',
  'Medica Government Programs',
  'Medica Health Plan Solutions',
  'Medicaid',
  'Medicaid of Alabama',
  'Medicaid of Alaska',
  'Medicaid of Arkansas',
  'Medicaid of Delaware',
  'Medicaid of Florida',
  'Medicaid of Georgia',
  'Medicaid of Idaho',
  'Medicaid of Illinois',
  'Medicaid of Indiana',
  'Medicaid of Iowa',
  'Medicaid of Kentucky',
  'Medicaid of Maryland',
  'Medicaid of Michigan',
  'Medicaid of Minnesota',
  'Medicaid of Mississippi',
  'Medicaid of Missouri',
  'Medicaid of Montana',
  'Medicaid of Nevada',
  'Medicaid of New Mexico',
  'Medicaid of New York',
  'Medicaid of North Carolina',
  'Medicaid of North Dakota',
  'Medicaid of Ohio',
  'Medicaid of Oklahoma',
  'Medicaid of Oregon',
  'Medicaid of Pennsylvania',
  'Medicaid of South Dakota',
  'Medicaid of Texas',
  'Medicaid of Utah',
  'Medicaid of Vermont',
  'Medicaid of Virginia',
  'Medicaid of Washington DC',
  'Medicaid of Washington State',
  'Medicaid of West Virginia',
  'Medicaid of Wisconsin',
  'Medicaid of Wyoming',
  'Medical Associates Health Plan',
  'Medical Benefits Mutual',
  'Medical Mutual',
  'Medicare',
  'Medicare Part B of Alabama',
  'Medicare Part B of Alaska',
  'Medicare Part B of American Samoa',
  'Medicare Part B of Arizona',
  'Medicare Part B of Arkansas',
  'Medicare Part B of Colorado',
  'Medicare Part B of Connecticut',
  'Medicare Part B of DC',
  'Medicare Part B of Delaware',
  'Medicare Part B of Eastern Missouri',
  'Medicare Part B of Florida',
  'Medicare Part B of Georgia',
  'Medicare Part B of Idaho',
  'Medicare Part B of Illinois',
  'Medicare Part B of Indiana',
  'Medicare Part B of Iowa',
  'Medicare Part B of Kansas',
  'Medicare Part B of Kentucky',
  'Medicare Part B of Louisiana',
  'Medicare Part B of Maine',
  'Medicare Part B of Maryland',
  'Medicare Part B of Massachusetts',
  'Medicare Part B of Michigan',
  'Medicare Part B of Minnesota',
  'Medicare Part B of Mississippi',
  'Medicare Part B of Montana',
  'Medicare Part B of Nebraska',
  'Medicare Part B of Nevada',
  'Medicare Part B of New Hampshire',
  'Medicare Part B of New Jersey',
  'Medicare Part B of New Mexico',
  'Medicare Part B of New York (Empire)',
  'Medicare Part B of North Carolina',
  'Medicare Part B of North Dakota',
  'Medicare Part B of Northern California',
  'Medicare Part B of Ohio',
  'Medicare Part B of Oklahoma',
  'Medicare Part B of Oregon',
  'Medicare Part B of Queens NY',
  'Medicare Part B of Rhode Island',
  'Medicare Part B of South Carolina',
  'Medicare Part B of South Dakota',
  'Medicare Part B of Southern California',
  'Medicare Part B of Tennessee',
  'Medicare Part B of Texas',
  'Medicare Part B of Upstate NY',
  'Medicare Part B of Utah',
  'Medicare Part B of Vermont',
  'Medicare Part B of Virginia',
  'Medicare Part B of Washington',
  'Medicare Part B of West Virginia',
  'Medicare Part B of Western Missouri',
  'Medicare Part B of Wisconsin',
  'Medicare Part B of Wyoming',
  'Medicare Railroad (MetraHealth Medicare)',
  'Medicare of Pennsylvania',
  'Medico',
  'Medplus',
  'Medstar Family Choice',
  'Memorial Hermann Health Network',
  'Mental Health Consultants Inc.',
  'Mercy Care (Arizona)',
  'Mercy EAP',
  'MercyCare of Wisconsin',
  'Meridian Health Plan',
  'Meridian Health Plan Illinois',
  'Meridian Health Plan Michigan',
  'Meritain Health',
  'MetLife',
  'MetroPlusHealth',
  'Michigan Medicare PlusBlue',
  'Mid-America Associates',
  'Midland Management',
  'Midlands Choice',
  'Midwest Health Partners',
  'Midwest Operating Engineers Fringe Benefit Funds',
  'Military OneSource EAP',
  'MinnesotaCare Blue Plus',
  'Missoula County Medical Benefits',
  'Moda Health',
  'Modern Health EAP',
  'Molina Healthcare',
  'Molina Healthcare Dual Eligible Special Needs Plan',
  'Molina Healthcare Utah',
  'Molina Healthcare of California',
  'Molina Healthcare of Florida',
  'Molina Healthcare of Idaho',
  'Molina Healthcare of Illinois',
  'Molina Healthcare of Iowa',
  'Molina Healthcare of Michigan',
  'Molina Healthcare of Mississippi',
  'Molina Healthcare of Nebraska',
  'Molina Healthcare of Nevada',
  'Molina Healthcare of New Mexico',
  'Molina Healthcare of Ohio',
  'Molina Healthcare of South Carolina',
  'Molina Healthcare of Texas',
  'Molina Healthcare of Virginia',
  'Molina Healthcare of Washington',
  'Mountain Health CO-OP',
  'Mountain Strong EAP',
  'MultiPlan',
  'Mutual of Omaha',
  'Mutual of Omaha EAP',
  'My Group EAP',
  'NDBH EAP',
  'NGS American',
  'NJ FamilyCare',
  'NYSHIP',
  'National Capital Administrative Services (NCAS)',
  'National EAP',
  'Nationwide',
  'Neighborhood Health Plan of Rhode Island',
  'Network Health',
  'Network Health Plan of Wisconsin Inc.',
  'NeueHealth',
  'New Era Life Insurance',
  'New York Network Management',
  'NextBlue of North Dakota',
  'Nippon Life Insurance Company',
  'Northern Nevada Trust Funds',
  'Northwell Direct',
  'NuVantage EAP',
  'Ohana Health Plan',
  'Ohio PPO Connect',
  'OhioRISE',
  'OptiMed Health',
  'Optum',
  'Optum Behavioral Health EAP',
  'Optum EAP',
  'Optum Health - Physical Health',
  'Optum San Diego Public Sector',
  'Oscar Health',
  'Out of Network',
  'Out of Pocket',
  'Oxford Health Plans',
  'PAS EAP',
  'PacificSource Community Solutions',
  'PacificSource Health Plans',
  'PacificSource Medicare',
  'Palmetto EAP',
  'Paramount Health Plan',
  'Parkland Community Health Plan',
  'Partnership Health Plan of California',
  'Passport by Molina Healthcare',
  'Peak Health',
  'Pekin Insurance',
  'Pennsylvania Keystone Health Plan East',
  'Peoples Health',
  'PerformCare',
  'Perspectives EAP',
  'Physicians Care Network (Rockford, IL)',
  'Physicians Health Plan',
  'Physicians Health Plan of Michigan',
  'Physicians Health Plan of Northern Indiana',
  'Physicians Health Plan of South Carolina',
  'Physicians Mutual',
  'Prairie States Enterprises',
  'Preferred Care Partners',
  'PreferredOne',
  'Premera Blue Cross',
  'Premera Blue Cross Blue Shield of Alaska',
  'Premera Blue Cross of Washington',
  'Presbyterian Health Plan',
  'Presbyterian Salud',
  'Primary PhysicianCare',
  'PrimeWest Health',
  'Priority Health',
  'Pro-Claim Plus',
  'Profile EAP',
  'Progressive',
  'Prominence Health Plan',
  'ProviDRs Care Network',
  'Providence Health Assurance',
  'Providence Health Plan',
  'Psychealth Care Management',
  'QualChoice Health Insurance',
  'Quality Care Partners',
  'Quartz Health Solutions',
  'RBH EAP',
  'REALiving EAP',
  'Reach EAP',
  'Redirect Health',
  'Reflect Health',
  'Regal Medical Group',
  'Regence',
  'Regence Blue Cross Blue Shield of Oregon',
  'Regence Blue Shield of Washington',
  'Regence BlueCross BlueShield of Utah',
  'Riverside Health',
  'Rocky Mountain Health Plans',
  'SCHC Total Care',
  'SEIU',
  'SIHO Insurance Services',
  'SISCO',
  'SKAI Blue Cross Blue Shield',
  'Sagamore Health Network',
  'Sage Technologies',
  'Samaritan Health Plans',
  'Sample EAP',
  'Sana',
  'Sana Benefits',
  'Sand Creek EAP',
  'Sanford Health Plan',
  'Sante Health Systems',
  'Sapphire EAP',
  'Security Health Plan',
  'Sedgwick',
  'Select Administrative Services',
  'Select Health',
  'Select Health of South Carolina',
  'Selman and Company',
  'Sentara Health Plans',
  'Sharp Health Plan',
  'Sierra Health and Life',
  'SilverSummit Healthplan',
  'Snedeker Risk Management',
  'Solarte Health',
  'Solutions EAP',
  'South County Health Alliance',
  'Southwest EAP',
  'Spring Health EAP',
  `St. Luke's Health Plan`,
  'State Farm',
  'SummaCare',
  'Summit Community Care',
  'Sunshine Health (Centene)',
  'Superior HealthPlan',
  'Surest',
  'Sutter Health EAP',
  'Sutter Health Plus',
  'TELUS Health EAP',
  'TRICARE',
  'TRICARE East',
  'TRICARE Overseas',
  'TRICARE West',
  'TRICARE for Life',
  `Texas Children's Health Plan`,
  'The Alliance',
  'The Care Network',
  'The Empire Plan',
  'The Hartford',
  'The Health Plan',
  'The Kempton Group',
  'The Loomis Company',
  'The Village EAP',
  'Three Rivers Preferred',
  'Total Plan Concepts',
  'Travelers',
  'TriHealth EAP',
  'TriWest Healthcare Alliance',
  'Triad EAP',
  'Tribado',
  'Trillium Health Resources',
  'Triple-S Salud',
  'TrueCare',
  'Trusteed Plans Service Corporation',
  'Tufts Health Plan',
  'UC Davis Health',
  'UCS Cement Masons',
  'UCS PBS Oregon',
  'UCS SecureOne Preferred United Plans',
  'UCare',
  'UHA',
  'UMC Health Plan',
  'UMR',
  'UMWA Health & Retirement Funds',
  'UNITE HERE HEALTH',
  'UPMC Health Plan',
  'US Family Health Plan (USFHP)',
  'USPS EAP',
  'UT Health Houston EAP',
  'Ulliance EAP',
  'Umpqua Health Alliance',
  'UniCare',
  'UniCare EAP',
  'Unified Group Services',
  'United American Insurance Company',
  'United Behavioral Health',
  'United EAP',
  'United Healthcare Oxford',
  'UnitedHealthOne',
  'UnitedHealthcare',
  'UnitedHealthcare Community Plan Michigan',
  'UnitedHealthcare Community Plan Mississippi',
  'UnitedHealthcare Community Plan Missouri',
  'UnitedHealthcare Community Plan New Jersey',
  'UnitedHealthcare Community Plan New York',
  'UnitedHealthcare Community Plan Ohio',
  'UnitedHealthcare Community Plan Pennsylvania',
  'UnitedHealthcare EAP',
  'Unity Health Care',
  'Unity Health Insurance',
  'Univera Healthcare',
  'University Health Alliance',
  'University of Illinois',
  'University of Utah Health Plans',
  'Upper Peninsula Health Plan',
  'Uprise Health',
  'Utah Public Employee Health Plan (PEHP)',
  'Valley Health Plan',
  'Varipro',
  'Vaya Health',
  'Ventura County Health Plan',
  'Veterans Affairs (VA) Community Care Network',
  'Vital Worklife EAP',
  'Vitori Health',
  'Viva Health Plan',
  'WPS Health Insurance',
  'Washington EAP',
  'WellMed',
  'WellSense Health Plan',
  'WellSpan EAP',
  'Wellcare (Centene)',
  'Wellcare of Connecticut',
  'Wellmark Blue Cross and Blue Shield Iowa',
  'Wellmark Blue Cross and Blue Shield South Dakota',
  'Wellpoint',
  'Wellpoint Arizona',
  'Wellspring EAP',
  `Western Grower's Assurance Trust`,
  'Western Health Advantage',
  'Western Pennsylvania Electrical Employees Insurance Trust Fund',
  'Wisconsin Commercial',
  'Yamhill Community Care Organization (YCCO)',
  'Zing Health',
  'iCare Health Plan',
];
